export default {
  TITLE: '亚马逊海外实体注册信息',
  CONTENT: `
    <div>
      <h3>亚马逊美国</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>主体名称</td>
          <td>Amazon Export Sales LLC</td>
        </tr>
        <tr>
          <td>注册国</td>
          <td>美国</td>
        </tr>
        <tr>
          <td>注册号</td>
          <td>3971236</td>
        </tr>
        <tr>
          <td>注册地址</td>
          <td>美国特拉华州威尔明顿市小佛斯路251号，邮编19808</td>
        </tr>
      </table>
      <h3>亚马逊英国/德国</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>主体名称</td>
          <td>Amazon EU S.à r.l.</td>
        </tr>
        <tr>
          <td>注册国</td>
          <td>卢森堡</td>
        </tr>
        <tr>
          <td>注册号</td>
          <td>B101818</td>
        </tr>
        <tr>
          <td>注册地址</td>
          <td>卢森堡肯尼迪大街38号，邮编L-1855</td>
        </tr>
      </table>
      <h3>亚马逊日本</h3>
      <table cellspacing="0" cellpadding="0">
        <tr>
          <td>主体名称</td>
          <td>Amazon Japan Godo Kaisha</td>
        </tr>
        <tr>
          <td>注册国</td>
          <td>日本</td>
        </tr>
        <tr>
          <td>注册号</td>
          <td>3040001028447</td>
        </tr>
        <tr>
          <td>注册地址</td>
          <td>日本东京都目黑区下目黑一丁目8番1号</td>
        </tr>
      </table>
    </div>
  `
};
